import { IResponse } from "models";

export enum ActionType {
  PATIENT_REGISTRATION = "action/PATIENT_REGISTRATION",
  PATIENT_REGISTRATION_SUCCESS = "action/PATIENT_REGISTRATION_SUCCESS",
  PATIENT_REGISTRATION_ERROR = "action/PATIENT_REGISTRATION_ERROR",
  PATIENT_REGISTRATION_RESET = "action/PATIENT_REGISTRATION_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IPatientRegistrationPayload {
  mobile_number: string;
  super_city_code?: string;
  identity_code?: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  gender?: number;
  date_of_birth?: string;
  password?: string;
  password_confirmation?: string;
}

export interface IPatientRegistrationResponse extends IResponse {
  result: any;
}
